import { PrimaryButton, SecondaryButton, TextLinkButton } from '../../button';
import { styleVariables } from '../../../style';
import styled from 'styled-components';
import { DeleteOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledPopup = styled.div.withConfig({
  displayName: "comment-popupcomponent__StyledPopup",
  componentId: "sc-cnto2r-0"
})(["border:1px solid ", ";background-color:", ";border-radius:", ";max-height:250px;min-width:360px;max-width:400px;min-height:200px;overflow:auto;z-index:1000;padding:5px 12px;"], function (props) {
  return props.theme.color.warning;
}, function (props) {
  return props.theme.color.backgroundPrimary;
}, styleVariables.borderRadius.medium);
var StyledEditIcon = styled.div.withConfig({
  displayName: "comment-popupcomponent__StyledEditIcon",
  componentId: "sc-cnto2r-1"
})(["display:flex;justify-content:flex-end;margin-bottom:", ";color:", ";"], styleVariables.margin.medium, function (props) {
  return props.theme.color.fontColorDefault;
});
var StyledDeleteButton = styled(TextLinkButton).withConfig({
  displayName: "comment-popupcomponent__StyledDeleteButton",
  componentId: "sc-cnto2r-2"
})(["color:", ";"], function (props) {
  return props.theme.color.error;
});
var StyledGroupButton = styled.div.withConfig({
  displayName: "comment-popupcomponent__StyledGroupButton",
  componentId: "sc-cnto2r-3"
})(["display:flex;justify-content:flex-end;margin-top:", ";"], styleVariables.margin.medium);
var StyledSaveButton = styled(TextLinkButton).withConfig({
  displayName: "comment-popupcomponent__StyledSaveButton",
  componentId: "sc-cnto2r-4"
})(["margin-left:", ";color:", ";&:hover{color:", ";}"], styleVariables.margin.extraLarge, function (props) {
  return props.theme.color.textPrimary;
}, function (props) {
  return props.theme.color.bgActive;
});
export var CommentPopup = function CommentPopup(_ref) {
  var position = _ref.position,
      commentId = _ref.commentId,
      content = _ref.content,
      isEditing = _ref.isEditing,
      onDelete = _ref.onDelete,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      onUpdateContent = _ref.onUpdateContent,
      labels = _ref.labels,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading;
  if (!position) return null;
  return /*#__PURE__*/_jsxs(StyledPopup, {
    className: "popup-comment",
    style: {
      position: 'fixed',
      top: position.top,
      left: position.left
    },
    children: [/*#__PURE__*/_jsx(StyledEditIcon, {
      className: "popup-comment",
      children: /*#__PURE__*/_jsx(StyledDeleteButton, {
        icon: /*#__PURE__*/_jsx(DeleteOutlined, {
          className: "popup-comment"
        }),
        onClick: function onClick() {
          return onDelete(commentId);
        },
        disabled: loading,
        className: "popup-comment"
      })
    }), isEditing ? /*#__PURE__*/_jsxs("div", {
      className: "popup-comment",
      children: [/*#__PURE__*/_jsx(Input.TextArea, {
        rows: 4,
        autoSize: {
          minRows: 4,
          maxRows: 6
        },
        placeholder: "Add comments",
        onChange: function onChange(e) {
          return onUpdateContent(e.target.value);
        },
        value: content,
        disabled: loading,
        className: "popup-comment"
      }), /*#__PURE__*/_jsxs(StyledGroupButton, {
        className: "popup-comment",
        children: [/*#__PURE__*/_jsx(SecondaryButton, {
          className: "popup-comment",
          onClick: onCancel,
          disabled: loading,
          size: "middle",
          children: labels.cancel
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          className: "popup-comment",
          loading: loading,
          onClick: function onClick() {
            return onSave(commentId, content);
          },
          size: "middle",
          style: {
            marginLeft: '12px'
          },
          children: labels.save
        })]
      })]
    }) : /*#__PURE__*/_jsx("p", {
      className: "popup-comment",
      children: content
    })]
  });
};